import HubHttpClient from 'ExportDialog/apiClients/HubHttpBaseClient';
import { rpcClient } from '../../client';
import { dispatchTeamProgressExportRpc } from '../../../__generated__/chirp/com/hubspot/academy/exports/rpc/TeamExportRpc';
import { convertToSupportedLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
export const ExportClient = exportType => {
  return Object.assign({}, HubHttpClient, {
    export: settings => {
      switch (exportType) {
        case 'MY_TEAM':
          {
            var _settings$language;
            return rpcClient.call(dispatchTeamProgressExportRpc, {
              request: {
                language: convertToSupportedLanguage((_settings$language = settings.language) === null || _settings$language === void 0 ? void 0 : _settings$language.split('-')[0]),
                format: (settings.format || 'CSV').toUpperCase()
              }
            });
          }
        default:
          return Promise.reject(new Error(`unexpected export type: ${exportType}`));
      }
    }
  });
};